export const NAME = 'search';

export const WEEK_DAYS = {
  0: 'common_sunday',
  1: 'common_monday',
  2: 'common_tuesday',
  3: 'common_wednesday',
  4: 'common_thursday',
  5: 'common_friday',
  6: 'common_saturday',
};

export const WEEK_DAYS_ORDER = [1, 2, 3, 4, 5, 6, 0];
